/* ==========================================================================
   PanelRoom > Client > Peoples
   ========================================================================== */

/* Modules */
const CounterClient = require('@bluekiri/alexandria-contrib-components/components/counter-rxjs/client/js');
// eslint-disable-next-line max-len
const ActionsCounter = require('@bluekiri/alexandria-contrib-components/components/counter-rxjs/client/js/store/actions');

const { hasAges } = require('./utils');
const { addAge, destroyAge } = require('./age');

const { actions, types } = require('../store/actions');

/* Init People Counters */
function initPeople(instance) {
    const result = instance;
    const { element, selector, reactions = {} } = instance;

    /* Init counter */
    const counters = [...element.querySelectorAll(`${selector} [data-component="CounterRxjs"]`)];
    result.people = counters.map(counter => {
        const { type = '' } = counter.dataset;

        return { counter: CounterClient(`${selector} [data-component="CounterRxjs"][data-type="${type}"]`) };
    });

    if (!result.people.length) return;

    /* Extends Actions */
    result.actions = {
        ...result.actions,
        addPeople: data => {
            const { index, value, ageValue } = data;

            /* Data */
            const { people = [] } = instance.store.select('data');
            const { ages = [] } = people[index] || {};

            /* Prepare payload */
            const payload = { index, value, ageValue, people };
            payload.people[index] = { value };
            if (ageValue !== undefined) payload.people[index].ages = [...ages, ageValue];

            return instance.store.dispatch(actions.addPeople(payload));
        },
        removePeople: index => {
            /* Data */
            const { people: peopleStore = [] } = instance.store.select('data');
            const { ages = [], value } = peopleStore[index] || {};

            /* Prepare payload */
            const room = [...peopleStore];
            const people = { value: value - 1 };

            if (ages) people.ages = ages.slice(0, -1);
            if (people.ages.length === 0) delete people.ages;

            room[index] = people;

            return instance.store.dispatch(actions.removePeople({ index, people: room }));
        },
        setAge: payload => instance.store.dispatch(actions.setAge(payload))
    };

    /* Extends reactions */
    result.reactions = {
        ...reactions,
        ...result.people
            .map((people, ind) => ({
                [`increment-people-${ind}`]: people.counter.store.subscribe((state, action) => {
                    if (action.type !== ActionsCounter.types.INCREMENT) return;

                    /**
                     * counter reference position
                     */
                    const index = result.people.indexOf(people);

                    const { config = {} } = instance;
                    const { people: peopleConfig = [] } = config;

                    /* Data */
                    const { value } = people.counter.store.select('counter');

                    /* Prepare payload */
                    const payload = { index, value };
                    if (hasAges(instance, index)) {
                        payload.ageValue = peopleConfig[index].options.find(item => item.selected).value;
                    }

                    /* Dispatch action */
                    instance.actions.addPeople(payload);
                    instance.actions.change();
                }),
                [`decrement-people-${ind}`]: people.counter.store.subscribe((state, action) => {
                    if (action.type !== ActionsCounter.types.DECREMENT) return;

                    /**
                     * counter reference position
                     */
                    const index = result.people.indexOf(people);

                    /* Dispatch action */
                    instance.actions.removePeople(index);
                    instance.actions.change();
                })
            }))
            .reduce((acc, val) => ({
                ...acc,
                ...val
            })),
        addPeople: instance.store.subscribe((state, action) => {
            if (action.type !== types.ADD_PEOPLE) return;

            /* New people, add age select */
            addAge(instance, action.payload);
        }),
        removePeople: instance.store.subscribe((state, action) => {
            if (action.type !== types.REMOVE_PEOPLE) return;

            /* Remove peoble, destroy age select */
            destroyAge(instance, action.payload.index);
        })
    };
}

/* Destroy people */
function destroyPeople(instance) {
    const { people = [] } = instance;

    if (people.length > 0) {
        people.forEach(item => {
            const { counter, ages } = item;

            /* Destroy select age */
            if (ages) {
                ages.forEach(age => {
                    if (age) age.actions.destroy();
                });
            }

            /* Destroy counters people */
            if (counter) counter.actions.destroy();
        });
    }
}

/* Export */
module.exports = {
    initPeople,
    destroyPeople
};
